import { useState, useEffect } from 'react';

type Orientation = 'landscape' | 'portrait';

type UseWindowSize = () => {
    width: number;
    height: number;
    orientation: Orientation;
};

const useWindowSize: UseWindowSize = () => {
    const [width, setWidth] = useState(1);
    const [height, setHeight] = useState(1);
    const [orientation, setOrientation] = useState<Orientation>('landscape');

    useEffect(() => {
        let timeout: number | null = null;

        const resizeHandler = () => {
            if (timeout) {
                window.clearTimeout(timeout);
                timeout = null;
            }

            const { innerWidth, innerHeight } = window;
            setWidth(innerWidth);
            setHeight(innerHeight);

            if (innerWidth >= innerHeight) {
                setOrientation('landscape');
            } else {
                setOrientation('portrait');
            }
        };

        const orientationChangeHandler = () => {
            if (timeout) {
                window.clearTimeout(timeout);
                timeout = null;
            }

            timeout = window.setTimeout(() => {
                resizeHandler();
            }, 200);
        };

        resizeHandler();
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
            window.removeEventListener('orientationchange', orientationChangeHandler);

            if (timeout) {
                window.clearTimeout(timeout);
                timeout = null;
            }
        };
    }, []);

    return {
        width,
        height,
        orientation,
    };
};

export default useWindowSize;
